import counterUp from 'counterup2'

const counterUpFigures = () => {
  const $years = $('.js-info-figures-figure-years');
  const $company = $('.js-info-figures-figure-companies');
  const $boiler = $('.js-info-figures-figure-boiler');

  if ($years.length && $company.length && $boiler.length) {
    const callback = (entries, obs) => {
      entries.forEach(entry => {
        const el = entry.target
        if (entry.isIntersecting) {
          counterUp(el, {
            duration: 1000,
            delay: 16,
          });

          obs.unobserve(entry.target);
        }
      })
    }

    const IO = new IntersectionObserver(callback, {threshold: 1})

    IO.observe($years[0]);
    IO.observe($company[0]);
    IO.observe($boiler[0]);
  }
}


export const mainPageFunctions = () => {
  counterUpFigures();
}